module.exports = require("lodash/isEqual");


//////////////////
// WEBPACK FOOTER
// external "lodash/isEqual"
// module id = 5
// module chunks = 0